import { createContext } from 'react';

const VestmapContext = createContext();

export default VestmapContext;
